import { Box, Stack, Typography } from "@mui/material";
import { icons } from "assets/AssetHelper";
import * as dayjs from "dayjs";

export const detailsData = ({ data, t }) => [
  {
    head: t("common.details"),
    icon: icons?.detailsIcon,
    details: [
      {
        label: t("wrappers_colors.name_en"),
        name: data?.localized_data?.en?.name,
      },
      {
        label: t("wrappers_colors.name_ar"),
        name: data?.localized_data?.ar?.name,
      },
      {
        label: t("wrappers_colors.presentation"),
        name: (
          <Stack direction="row" columnGap="8px">
            <Box
              width="24px"
              height="24px"
              bgcolor={data?.presentation}
              borderRadius="50%"
            ></Box>
            <Typography color={"#1a1a1a"} fontFamily="Cairo">
              {data?.presentation}
            </Typography>
          </Stack>
        ),
      },
    ],
  },
  {
    head: t("details.dates"),
    icon: icons.datesIcons,
    details: [
      {
        label: t("details.created_at"),
        name: dayjs(data?.created_at).format("DD-MM-YYYY HH:MM a"),
      },
      {
        label: t("details.updated_at"),
        name: dayjs(data?.updated_at).format("DD-MM-YYYY HH:MM a"),
      },
    ],
  },
];
